<template>
  <v-container>
    <h1 class="text-center grey--text text--darken-2 mt-4 mb-5">
      Testimonials
    </h1>
    <v-carousel
      class="d-none d-md-block pb-5"
      hide-delimiter-background
      next-icon=""
      prev-icon=""
      height="100%"
    >
      <v-carousel-item v-for="(slide, index) in slides" :key="index">
        <v-row align="stretch" justify="center">
          <v-col cols="12">
            <v-row
              align="stretch"
              justify="center"
              class="grey lighten-5"
              style="height: 100%;"
            >
              <v-col cols="4" v-for="(part, index) in slide.parts" :key="index">
                <v-card
                  class="card-responsive card-outter mx-auto"
                  color="#47abe1"
                  max-width="405"
                  min-width="275"
                  dark
                >
                  <v-card-text class="text-h6 font-style">
                    <p>"{{ part.content }}"</p>
                  </v-card-text>

                  <v-card-actions class="card-actions-custom">
                    <v-list-item>
                      <v-list-item-avatar color="grey darken-3">
                        <v-img
                          class="elevation-6"
                          src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"
                        ></v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title
                          >{{ part.name }}<br />
                          {{ part.title }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-carousel-item>
    </v-carousel>
    <v-carousel
      cycle
      class="d-block d-md-none pb-5"
      hide-delimiter-background
      next-icon=""
      prev-icon=""
      height="100%"
    >
      <div v-for="(slide, index) in slides" :key="index">
        <v-carousel-item v-for="(part, index) in slide.parts" :key="index">
          <v-row align="stretch" justify="center">
            <v-col cols="12">
              <v-row
                align="stretch"
                justify="center"
                class="grey lighten-5"
                style="height: 100%;"
              >
                <v-col cols="12">
                  <v-card
                    class="card-responsive card-outter mx-auto"
                    color="#47abe1"
                    max-width="405"
                    min-width="275"
                    dark
                  >
                    <v-card-text class="text-h6 font-style">
                      <p>"{{ part.content }}"</p>
                    </v-card-text>

                    <v-card-actions class="card-actions-custom">
                      <v-list-item>
                        <v-list-item-avatar color="grey darken-3">
                          <v-img
                            class="elevation-6"
                            src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"
                          ></v-img>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title
                            >{{ part.name }}<br />
                            {{ part.title }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-carousel-item>
      </div>
    </v-carousel>
    <v-row class="mt-5 pt-5" align="center" justify="center">
      <v-col cols="12" md="10" lg="10" xl="8">
        <v-row align="center" justify="center">
          <v-col v-for="n in 5" :key="n" class="d-flex child-flex">
            <v-card flat tile class="d-flex">
              <v-img
                :src="require('../assets/' + n + '.jpg')"
                aspect-ratio="1"
                contain
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="10" lg="10" xl="8">
        <v-row align="center" justify="center">
          <v-col v-for="n in 5" :key="n" class="d-flex child-flex">
            <v-card flat tile class="d-flex">
              <v-img
                :src="require('../assets/' + (n + 5) + '.jpg')"
                aspect-ratio="1"
                contain
              >
                <template v-slot:placeholder>
                  <v-row class="ma-0" align="center" justify="center">
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Landing5Testimonials",

  data: () => ({
    colors: [
      "indigo",
      "warning",
      "pink darken-2",
      "red lighten-1",
      "deep-purple accent-4",
    ],
    color: "#47abe1",
    slides: [
      {
        parts: [
          {
            content:
              "All I do is book, and KAHON.PH does all the work! They make my life so much easier and clutter-free!",
            name: "Nicole Andersson",
            title: "Social Media Influencer",
            image: "",
          },
          {
            content:
              "KAHON.PH, you're a blessing to this industry.  You pick up, seal, store, and deliver. Your system is simple yet effective. Your service is great. Your reps are knowledgeable and friendly. Above all, you have the best value for money. In this global age where businesses grow and expand rapidly, storage space is a valuable commodity. So when you need to store something, look up KAHON.PH first.",
            name: "Brian Masigan",
            title: "",
            image: "",
          },
          {
            content:
              "Sandstone Technology has been a client of KAHON.PH for more than 2 years now. Everything is great! Communication with their customer service is always easy and prompt. Thank you, KAHON.PH!",
            name: "Beth Miranda-Maik",
            title: "Sandstone Technology",
            image: "",
          },
        ],
      },
      {
        parts: [
          {
            content:
              "I run a small business and store most of my bazaar equipment is in my apartment, but I’m glad I found out about KAHON.PH. I now have a secure place to store my materials. The Spacemakers were really helpful and efficient in packing all of my stuff. It took less than an hour for them to pack, label, and store everything. Booking an appointment was super easy as well, so thank you, KAHON.PH!",
            name: "Ana Batiller",
            title: "Owner Cora and Bear",
            image: "",
          },
          {
            content:
              "Exceptional service! Everything from booking to pick-up was a breeze.  Customer service was very professional, and answered my calls and texts promptly. The Spacemakers were friendly, patient and efficient, and were so thorough in wrapping our things! The way this company does things, paying attention to even small details, assures me as a customer that my belongings are in trustworthy hands.",
            name: "Roxanne Chen Villareal",
            title: "",
            image: "",
          },
          {
            content:
              "Highly efficient, highly recommendable, stress-free service! They almost did everything for me, and the best thing is I didn’t even need to go out of the house. From the time I inquired, their customer service was so efficient and quick to answer. The Spacemakers have been incredibly helpful. They listen to all my concerns. The Spacemakers who packed, wrapped and picked up my stuff were so fast and efficient. I am so happy that it took out all the stress from doing this on my own. I highly recommend this company. Thank you so much!",
            name: "Ethelyn Hahne",
            title: "",
            image: "",
          },
        ],
      },
    ],
  }),
};
</script>

<style scoped>
::v-deep .theme--dark.v-btn.v-btn--icon{
  color: #47abe1 !important;
}

.card-responsive {
  height: 100% !important;
}

.card-actions-custom {
  position: absolute !important;
  bottom: 0 !important;
}

.card-outter {
  position: relative !important;
  padding-bottom: 50px !important;
}

::v-deep .v-carousel__controls {
  bottom: -10px !important;
}
</style>
